'use client';

import { Button } from '@curology/ui-components-web/react/Button';
import React from 'react';

import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { EmailVerificationService } from '@/services/emailVerificationService/client';

import { useNavigating } from './useNavigating';
import { useFlowContext } from '../../hooks/useFlowContext';

export const ResendVerifyEmailButton = () => {
  const { brand } = useFlowContext();
  const { onNext } = useNavigation();
  const [isNavigating, setIsNavigating] = useNavigating();

  const handleClick = async () => {
    if (isNavigating) {
      return;
    }
    setIsNavigating(true);

    await EmailVerificationService.sendEmailVerification(brand);
    onNext();
    setIsNavigating(false);
  };

  return (
    <Button className="cur-w-full" onClick={handleClick} loading={isNavigating}>
      Resend email
    </Button>
  );
};
